import store from '../store/store';
import TranslationSettings from '../store/schema/TranslationSettings';
import updateTranslationSettings from './updateTranslationSettings';

export default async function addExcludedLanguage(language: string) {
    if (
        !store.settings.excludedLanguages ||
        !language ||
        store.settings.excludedLanguages.includes(language)
    ) {
        return;
    }

    const newSettings: TranslationSettings = {
        translationMode: store.settings.translationMode,
        targetLanguage: store.settings.targetLanguage,
        excludedLanguages: [...store.settings.excludedLanguages],
        initialized: true,
    };
    newSettings.excludedLanguages.push(language);

    await updateTranslationSettings(newSettings);
}
